import React from 'react';

import type { WidgetFC } from '@swf/core/types/Widget';
import { CommonStylesProvider, initModuleNativeClient } from '@swf/poker';

import PowerPath from './components/PowerPath/PowerPath';
import { pokerPowerPathWidgetModel } from './model';

// This is needed to enable spinandgo functionality in desktop client, so to be able to launch step1 game
initModuleNativeClient('spinandgo');

const PokerPowerPathWidget: WidgetFC = () => (
  <CommonStylesProvider>
    <PowerPath />
  </CommonStylesProvider>
);

PokerPowerPathWidget.model = pokerPowerPathWidgetModel;

export default PokerPowerPathWidget;
